// The house eyebrow — a mono, uppercase, atlas-teal label with a slow pulsing dot (book §07:
// eyebrow is the accent, +0.14em). Cobalt stays the link/CTA colour; teal is the identity accent.
export function Eyebrow({ children }: { children: string }) {
  return (
    <span
      className="inline-flex items-center gap-2 text-xs font-mono uppercase text-accent border border-accent/30 rounded-full px-3 py-1 mb-5"
      style={{ letterSpacing: '0.14em' }}
    >
      <span className="inline-block w-1.5 h-1.5 rounded-full bg-accent animate-pulse-slow" />
      {children}
    </span>
  )
}
